import { render, staticRenderFns } from "./PageLogin.vue?vue&type=template&id=5896dbaf"
import script from "./PageLogin.vue?vue&type=script&lang=js"
export * from "./PageLogin.vue?vue&type=script&lang=js"
import style0 from "./PageLogin.vue?vue&type=style&index=0&id=5896dbaf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports